<form [formGroup]="signUpForm" (ngSubmit)="registrationSubmit()">
  <div class="login-page">
    <div class="container-fluid d-flex justify-content-center py-2">
      <div class="login-container">
        <img src="logo/logo.png" alt="Logo" class="logo" />
        <p class="login-text">Welcome! Please fill in the details below.</p>

        <!-- Recruiter toggle -->
        <div class="input-group recruiter-toggle">
          <div class="switch-row">
            <label class="switch-label" for="is_recruiter">
              I am a recruiter / hiring manager
            </label>
            <label class="switch">
              <input
                type="checkbox"
                id="is_recruiter"
                formControlName="is_recruiter"
                role="switch"
                [attr.aria-checked]="isRecruiter"
                (change)="toggleSeekerValidators(isRecruiter)"
              />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <!-- Email -->
        <div class="input-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control"
            placeholder="Enter your email"
            autocomplete="username email"
            readonly
          />
        </div>

        <!-- Password -->
        <div class="input-group">
          <ng-container *ngIf="hidePasswordField; else passwordInput">
            <label>Password</label>
            <input type="text" class="form-control" value="••••••••" disabled />
          </ng-container>
          <ng-template #passwordInput>
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              formControlName="password"
              class="form-control"
              placeholder="Enter your password"
              autocomplete="new-password"
            />
          </ng-template>
        </div>

        <!-- Name -->
        <div class="input-group">
          <label for="name">Name</label>
          <input
            type="text"
            id="name"
            formControlName="name"
            class="form-control"
            placeholder="Enter your name"
            autocomplete="name"
          />
        </div>

        <!-- Designation (visible for both, optional when recruiter) -->
        <div class="input-group">
          <label for="designation">Designation</label>
          <input
            type="text"
            id="designation"
            formControlName="designations"
            class="form-control"
            placeholder="Enter your designation"
            autocomplete="organization-title"
          />
        </div>

        <!-- Phone (Optional, visible for both) -->
        <div class="input-group">
          <label for="phone">Phone (Optional)</label>
          <div class="phone-wrapper">
            <select
              class="form-select"
              formControlName="country_code"
              aria-label="Country dial code"
            >
              <option
                *ngFor="let country of MobileCountries"
                [value]="country.dialCode"
              >
                {{ country.name }} (+{{ country.dialCode }})
              </option>
            </select>
            <input
              type="tel"
              id="phone"
              formControlName="phone"
              class="form-control"
              placeholder="Enter your phone number"
              autocomplete="tel-national"
              inputmode="tel"
              pattern="[\d\s\-()]*"
            />
          </div>
        </div>

        <!-- About Me (Optional, visible for both) -->
        <div class="input-group">
          <label for="about_me">About Me (Optional)</label>
          <textarea
            id="about_me"
            class="form-control"
            rows="4"
            formControlName="about_me"
            maxlength="2500"
            (input)="onAboutMeChange()"
            placeholder="Tell us about yourself (max 2500 characters)"
          ></textarea>
          <small class="text-muted d-block text-end">
            {{ aboutMeLength }}/2500 characters
          </small>
        </div>

        <!-- Resume (Optional) -->
        <div class="input-group d-flex flex-column" [class.d-none]="isRecruiter">
          <label for="resume_input">Resume (Optional)</label>

          <!-- Hidden file input -->
          <input
            type="file"
            id="resume_input"
            class="d-none"
            (change)="onResumeFileChange($event)"
            accept=".pdf,application/pdf"
          />

          <div class="resume-row mt-2">
            <button
              type="button"
              class="btn btn-outline-light"
              (click)="triggerResumeBrowse()"
            >
              Choose File
            </button>

            <span class="file-pill" *ngIf="resumeName">
              <span class="file-name" [title]="resumeName">{{ resumeName }}</span>
              <button
                type="button"
                class="btn btn-sm btn-link text-danger ms-2"
                (click)="clearResume()"
              >
                Remove
              </button>
            </span>
          </div>
        </div>

        <!-- Availability (Optional, popup) -->
        <div class="input-group d-flex flex-column" [class.d-none]="isRecruiter">
          <label>Availability (Optional)</label>

          <div class="resume-row mt-2">
            <button
              type="button"
              class="btn btn-outline-light"
              (click)="openAvailabilityPopup()"
            >
              Set Availability
            </button>

            <!-- Compact summary once saved -->
            <small class="text-muted" *ngIf="availability">
              <strong>Saved:</strong>
              <ng-container *ngIf="availability.mode === 'now'">Immediate</ng-container>
              <ng-container *ngIf="availability.mode === 'date'">
                From {{ availability.start_at | date : 'mediumDate' }}
              </ng-container>
              <ng-container *ngIf="availability.duration_label">
                · {{ availability.duration_label }}
              </ng-container>
            </small>
          </div>
        </div>

        <!-- Seeker-only section -->
        <div [class.d-none]="isRecruiter">
          <!-- Work Experience -->
          <div class="input-group">
            <label for="experience_years_id">Work Experience</label>
            <select
              class="form-select"
              id="experience_years_id"
              formControlName="experience_years_id"
            >
              <option value="">Select Experience</option>
              <option
                *ngFor="let obj of workExperience"
                [value]="obj.experience_years_id"
              >
                {{ obj.value }}
              </option>
            </select>
          </div>

          <!-- Nationality -->
          <div class="input-group">
            <label for="country_id">Nationality</label>
            <select
              class="form-select"
              id="country_id"
              formControlName="country_id"
            >
              <option value="">Select Nationality</option>
              <option *ngFor="let obj of countries" [value]="obj.country_id">
                {{ obj.value }}
              </option>
            </select>
          </div>
        </div>

        <!-- Submit -->
        <button
          class="btn login-btn mt-3 w-100"
          type="submit"
          [disabled]="!signUpForm.valid"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Availability Modal -->
<ng-template #availabilityModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Set Availability</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="availabilityForm">
      <div class="mb-3">
        <label class="form-label">Availability Mode</label>
        <select class="form-select" formControlName="mode" (change)="onModeChange()">
          <option value="now">Available Now</option>
          <option value="date">Available from Date</option>
        </select>
      </div>

      <div class="mb-3" *ngIf="availabilityForm.get('mode')?.value === 'now'">
        <label class="form-label">Notice Period (if any)</label>
        <select class="form-select" formControlName="duration_id">
          <option [ngValue]="null">Select Duration</option>
          <option *ngFor="let d of availabiltyDurations" [ngValue]="d.duration_id">
            {{ d.value }}
          </option>
        </select>
      </div>

      <div class="mb-3" *ngIf="availabilityForm.get('mode')?.value === 'date'">
        <label class="form-label">Start Date</label>
        <input type="date" class="form-control" formControlName="start_at" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button
      class="btn btn-primary btn-lite-blue"
      (click)="saveAvailability()"
      [disabled]="availabilityForm.value.mode === 'now' && !availabilityForm.value.duration_id"
    >
      Save
    </button>
  </div>
</ng-template>
